import React, { PropTypes, Component } from 'react'
import styles from './styles'

export default class ReviewRow extends Component {
  static propTypes = {
    me: PropTypes.object,
    review: PropTypes.object,
    projects: PropTypes.array,
    projectNames: PropTypes.object,
    userNames: PropTypes.object,
    onWeekReportChange: PropTypes.func,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { me, review, projects, projectNames, userNames, onWeekReportChange } = this.props

    let showReviewButton = false
    if (me && (me.role === 'admin' || me.role === 'manager')) {
      showReviewButton = true
    } else {
      projects.forEach(p => {
        if (p._id === review.projectId && p.usersId === me._id) {
          showReviewButton = true
        }
      })
    }

    let acceptButton = null
    let rejectButton = null

    if (showReviewButton) {
      const onAcceptClick = () => onWeekReportChange('accept', review.projectId, me._id)
      acceptButton = <div className={styles.acceptButton} onClick={onAcceptClick}>{me.name}</div>
      const onRejectClick = () => onWeekReportChange('reject', review.projectId, me._id)
      rejectButton = <div className={styles.rejectButton} onClick={onRejectClick}>{me.name}</div>
    }

    return (
      <div className={styles.reviewRow} >
        <div className={styles.projectName} >{projectNames[review.projectId]}</div>
        <div className={styles.overtime} >{(review.hHour / 2).toFixed(1)}</div>
        <div className={styles.accept} >
          {review.state === 'accept' ?
            <div className={styles.acceptText}>{userNames[review.userId]}</div> : acceptButton}
        </div>
        <div className={styles.reject} >
          {review.state === 'reject' ?
            <div className={styles.rejectText}>{userNames[review.userId]}</div> : rejectButton}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/reviewRow.jsx